import { useEffect } from 'react';
import { useQuery } from 'react-query';

import { communicationServices } from '@services';
import { showError } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';

export const useSubscriptionSmsOperations = () => {
  const templatesResponse = useQuery(
    [QUERY_KEYS.GET_SUBSCRIPTION_SMS_TEMPLATES_KEY],
    () => communicationServices.getSMSTemplates()
  );

  const loading = templatesResponse?.isLoading;

  useEffect(() => {
    if (templatesResponse?.error) {
      showError(templatesResponse?.error);
    }
  }, [templatesResponse?.error]);

  const templates = Array.isArray(templatesResponse?.data?.data)
    ? templatesResponse?.data?.data?.map((item) => ({
        ...item,
        text: item.name,
        value: item.name,
      }))
    : [];
  return {
    loading,
    templates,
    getTemplates: templatesResponse.refetch,
  };
};
